/**
 * Mock nomination data for demo mode
 * Requirements: 2.4, 3.1, 5.1
 */

import {
  Nomination,
  NominationStatus,
  AwardType,
  AuditEntry,
} from '../types/nomination';

export const DEMO_NOMINATIONS: Nomination[] = [
  {
    id: 'nom-1',
    nomineeId: 'user-employee-1',
    nomineeName: 'John Employee',
    nominatorId: 'user-manager-1',
    nominatorName: 'Jane Manager',
    awardType: AwardType.SPOT,
    reason: 'Exceptional debugging of production issue within 30 minutes',
    supportingDetails: 'Resolved critical payment gateway outage affecting 500+ users.',
    status: NominationStatus.PUBLISHED,
    reviewerNotes: [
      {
        id: 'note-1',
        nominationId: 'nom-1',
        reviewerId: 'user-admin-1',
        reviewerName: 'Finance Admin',
        content: 'Well-deserved recognition for quick incident response.',
        createdAt: '2025-11-05T10:00:00Z',
      },
    ],
    publishedAt: '2025-11-06T09:00:00Z',
    publishedBy: 'user-admin-1',
    createdAt: '2025-11-01T08:00:00Z',
    updatedAt: '2025-11-06T09:00:00Z',
  },
  {
    id: 'nom-2',
    nomineeId: 'user-employee-2',
    nomineeName: 'Sarah Developer',
    nominatorId: 'user-manager-1',
    nominatorName: 'Jane Manager',
    awardType: AwardType.QUARTERLY,
    reason: 'Consistently delivered high-quality code reviews for the team',
    status: NominationStatus.APPROVED,
    reviewerNotes: [
      {
        id: 'note-2',
        nominationId: 'nom-2',
        reviewerId: 'user-admin-1',
        reviewerName: 'Finance Admin',
        content: 'Strong candidate. Code review metrics support this nomination.',
        createdAt: '2025-12-10T14:00:00Z',
      },
    ],
    createdAt: '2025-12-01T09:00:00Z',
    updatedAt: '2025-12-10T14:00:00Z',
  },
  {
    id: 'nom-3',
    nomineeId: 'user-employee-1',
    nomineeName: 'John Employee',
    nominatorId: 'user-manager-2',
    nominatorName: 'Bob TeamLead',
    awardType: AwardType.QUARTERLY,
    reason: 'Led cross-functional collaboration on the Q4 product launch',
    supportingDetails: JSON.stringify({ majorInitiative: 'Led cross-functional collaboration on the Q4 product launch', scaleOfImpact: { multipleTeams: true, clientWide: true }, measurableOutcomes: 'Coordinated between engineering, design, and QA teams.', leadershipQualities: { ledIndependently: true, crossTeamCollaboration: true }, sustainableImpact: 'yes', sustainableExplanation: 'Established repeatable launch process', standOutReason: 'First time cross-team coordination was done this effectively' }),
    status: NominationStatus.SUBMITTED,
    reviewerNotes: [],
    createdAt: '2025-12-15T11:00:00Z',
    updatedAt: '2025-12-15T11:00:00Z',
  },
  {
    id: 'nom-4',
    nomineeId: 'user-employee-2',
    nomineeName: 'Sarah Developer',
    nominatorId: 'user-manager-2',
    nominatorName: 'Bob TeamLead',
    awardType: AwardType.QUARTERLY,
    reason: 'Outstanding mentorship of three junior developers throughout the year',
    status: NominationStatus.UNDER_REVIEW,
    reviewerNotes: [
      {
        id: 'note-3',
        nominationId: 'nom-4',
        reviewerId: 'user-admin-1',
        reviewerName: 'Finance Admin',
        content: 'Reviewing mentorship impact metrics.',
        createdAt: '2025-12-18T09:00:00Z',
      },
    ],
    createdAt: '2025-12-10T10:00:00Z',
    updatedAt: '2025-12-18T09:00:00Z',
  },
  {
    id: 'nom-5',
    nomineeId: 'user-employee-1',
    nomineeName: 'John Employee',
    nominatorId: 'user-manager-1',
    nominatorName: 'Jane Manager',
    awardType: AwardType.SPOT,
    reason: 'Proactive security vulnerability identification and patching',
    status: NominationStatus.REJECTED,
    reviewerNotes: [
      {
        id: 'note-4',
        nominationId: 'nom-5',
        reviewerId: 'user-admin-1',
        reviewerName: 'Finance Admin',
        content: 'This was part of regular duties. Consider for quarterly instead.',
        createdAt: '2025-12-12T16:00:00Z',
      },
    ],
    createdAt: '2025-12-08T13:00:00Z',
    updatedAt: '2025-12-12T16:00:00Z',
  },
  {
    id: 'nom-6',
    nomineeId: 'user-employee-2',
    nomineeName: 'Sarah Developer',
    nominatorId: 'user-manager-1',
    nominatorName: 'Jane Manager',
    awardType: AwardType.QUARTERLY,
    reason: 'Improved CI/CD pipeline reducing build times by 40%',
    status: NominationStatus.DRAFT,
    reviewerNotes: [],
    createdAt: '2025-12-20T08:00:00Z',
    updatedAt: '2025-12-20T08:00:00Z',
  },
  {
    id: 'nom-7',
    nomineeId: 'user-employee-1',
    nomineeName: 'John Employee',
    nominatorId: 'user-manager-2',
    nominatorName: 'Bob TeamLead',
    awardType: AwardType.SPOT,
    reason: 'Volunteered to cover on-call shifts during holiday season',
    status: NominationStatus.PUBLISHED,
    reviewerNotes: [],
    publishedAt: '2025-10-20T12:00:00Z',
    publishedBy: 'user-admin-1',
    createdAt: '2025-10-15T09:00:00Z',
    updatedAt: '2025-10-20T12:00:00Z',
  },
];

export const DEMO_AUDIT_ENTRIES: AuditEntry[] = [
  {
    id: 'audit-1',
    nominationId: 'nom-1',
    action: 'PUBLISHED',
    performedBy: 'user-admin-1',
    performedByName: 'Finance Admin',
    details: 'Nomination published to feed',
    timestamp: '2025-11-06T09:00:00Z',
  },
  {
    id: 'audit-2',
    nominationId: 'nom-5',
    action: 'REJECTED',
    performedBy: 'user-admin-1',
    performedByName: 'Finance Admin',
    details: 'Nomination rejected: part of regular duties',
    timestamp: '2025-12-12T16:00:00Z',
  },
];
